import { IAcademicEducation } from "../../shared/model/academic-education.model";
import { IAddress } from "../../shared/model/address.model";
import { ICandidateLanguage } from "../../shared/model/candidate-language.model";
import { ICandidateMedicalInformation } from "../../shared/model/candidate-medical-information.model";
import { ICandidateQuestionResponse } from "../../shared/model/candidate-question-response.model";
import { ICandidateToApplication } from "../../shared/model/candidate-to-application.model";
import { ICandidate } from "../../shared/model/candidate.model";
import { IContactInformation } from "../../shared/model/contact-information.model";
import { ICountry } from "../../shared/model/country.model";
import { IDocument } from "../../shared/model/document.model";
import { CandidateApplicationState } from "../../shared/model/enumerations/candidate-application-state.model";
import { CareerStatus } from "../../shared/model/enumerations/career-status.model";
import { CivilStatus } from "../../shared/model/enumerations/civil-status.model";
import { DocumentType } from "../../shared/model/enumerations/document-type.model";
import { EducationalAttainment } from "../../shared/model/enumerations/educational-attainment.model";
import { FileType } from "../../shared/model/enumerations/file-type.model";
import { Gender } from "../../shared/model/enumerations/gender.model";
import { LanguageLevel } from "../../shared/model/enumerations/language-level.model";
import { phoneType } from "../../shared/model/enumerations/phone-type.model";
import { YesNo } from "../../shared/model/enumerations/yes-no.model";
import { IJobExperience } from "../../shared/model/job-experience.model";
import { IPerson } from "../../shared/model/person.model";
import { IProvince } from "../../shared/model/province.model";
import { IReferred } from "../../shared/model/referred.model";
import { ITechResource } from "../../shared/model/tech-resource.model";

export interface IAddresFormik extends IAddress {
  country: ICountry | null;
  province: IProvince | null;
}

export const initialDataPerson: IPerson = {
  firstName: "",
  lastName: "",
  documentType: DocumentType.ID,
  document: "",
  birthDate: "",
  gender: Gender.OTHERS,
  country: null,
  cuil: "",
  mail: "",
  civilStatus: CivilStatus.OTHERS,
};

export const initialDataAddress: IAddresFormik = {
  street: "",
  number: "",
  zipCode: "",
  country: null,
  province: null,
  locality: null,
};

export const initialDataContact: IContactInformation = {
  mobileNumber: "",
  alternativePhoneNumber: "",
  contactAlternativeName: "",
  countryCode: "54",
  alternativeCountryCode: "54",
  phoneType: phoneType.Movil,
};

export const initialMedicalInformation: ICandidateMedicalInformation = {
  disability: YesNo.NO,
  disabilityCertificate: YesNo.NO,
};

export const newAcademics: IAcademicEducation = {
  degree: "",
  educationalAttainment: EducationalAttainment.HIGHSCHOOL,
  country: null,
  careerStatus: CareerStatus.IN_PROGRESS,
};
export const initialAcademics: IAcademicEducation[] = [];

export const newJobExperience: IJobExperience = {
  jobPlace: "",
  jobTitle: "",
  tasks: "",
};
export const initialJobExperience: IJobExperience[] = [];

export const newLanguage: ICandidateLanguage = {
  language: null,
  writtenLevel: LanguageLevel.BASIC,
  spokenLevel: LanguageLevel.BASIC,
};
export const initialLanguage: ICandidateLanguage[] = [];

export const initialDataTechResource: ITechResource = {
};

export const newDocument: IDocument = {
  name: "",
  file: "",
  documentType: FileType.FILE,
  attachedFile: "",
};
const documentFront = {
  ...newDocument,
  name: "documentFrente",
};
const documentBack = {
  ...newDocument,
  name: "documentDorso",
};
const cv = {
  ...newDocument,
  name: "cv",
};
const documents = [cv, documentFront, documentBack];

const initialDataCandidateToApplication: ICandidateToApplication[] = [
  {
    state: CandidateApplicationState.PENDING,
  },
];

const initialDataReferred: IReferred[] = [{}];

export const newCandidateResponse: ICandidateQuestionResponse = {
  response: "",
  applicationQuestion: null,
  attachedFile: "",
  file: "",
};
const initialCandidateResponses: ICandidateQuestionResponse[] = [];

export const initialValues: ICandidate = {
  person: initialDataPerson,
  contactInformation: initialDataContact,
  candidateMedicalInformation: initialMedicalInformation,
  address: initialDataAddress,
  academicEducations: initialAcademics,
  languages: initialLanguage,
  techResource: initialDataTechResource,
  jobExperiences: initialJobExperience,
  candidateToApplications: initialDataCandidateToApplication,
  referreds: initialDataReferred,
  candidateQuestionResponses: initialCandidateResponses,
  documents,
};
